/**
 * Settings > Usage. Cards render top to bottom in this order; add new usage
 * admin cards here (CLAUDE.md §3.6).
 */
import React from 'react';
import UsageReportingCard from '../../../../components/admin/UsageReportingCard';
import UsageCounterRecoveryCard from '../../../../components/admin/UsageCounterRecoveryCard';
import CreditPacksCard from '../../../../components/admin/CreditPacksCard';

export default function UsageSettingsSection() {
  return (
    <>
      <UsageReportingCard />

      {/* Usage Counter Recovery */}
      <UsageCounterRecoveryCard />

      {/* Credit Packs Management */}
      <CreditPacksCard />
    </>
  );
}
